import * as React from "react"
import type { IconProps } from "../types"

const CrossHair = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", size = 24, ...props }, ref) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        ref={ref}
        viewBox="0 0 24 24"
        {...props}
      >
        <path
          stroke={color}
          strokeLinecap="square"
          strokeWidth={2}
          d="M12 2V8M22 12H16M12 16V22M8 12H2M12 19C8.13401 19 5 15.866 5 12C5 8.13401 8.13401 5 12 5C15.866 5 19 8.13401 19 12C19 15.866 15.866 19 12 19Z"
        />
      </svg>
    )
  }
)
CrossHair.displayName = "CrossHair"

export default CrossHair